import {WithNamespaces, withNamespaces} from "react-i18next";
import {TranslationFunction} from "i18next";
import * as React from "react";

export const GroupType = withNamespaces()( (props: {articleType?: string; ccGtZero?: number; } & WithNamespaces) => {
  return <>{getGroupType(props.articleType, props.ccGtZero, props.t)}</>;
});

export const getGroupType = (articleType: string | undefined, ccGtZero: number | undefined, t: TranslationFunction) => {
  const combined = (articleType || '') + ccGtZero;
  switch(combined) {
    case 'S0':
      return t('Offer.CutSTW');
    case 'S1':
      return t('Offer.CutCC');
    case 'T0':
      return t('Offer.PotSTW');
    case 'T1':
      return t('Offer.PotCC');
    default:
      return '';
  }
}